export const questions = [
  {
    id: 1,
    question: "How does Dauth protocol work ?",
    answer:
      "Dauth contains various ucpi nodes that works on signing of jwt hash(generated by web2 auth providers) if they are found true .all the node signature goes to ucpi smartcontract where smartcontract check for minimum 51% signature if found address is authencticated",
  },
  {
    id: 2,
    question: "How does the protocol authenticates Web2 Ids in a decentralised manner ?",
    answer:
      "Every web2 auth gives jwt which every is independently verified by every ucpi nodes   and all signatures goes to smartcontract  this makes it decentralized",
  },
  {
    id: 3,
    question: "What is the output of dAuth smart contract?",
    answer:
      "Hash of web2 id and login status;",
  },
  {
    id: 4,
    question: "What is the fee to be paid by a Dapp to use dAuth?",
    answer:
      "Currently it will free but in future version it will be decided by governing ucpi nodes",
  },
  {
    id: 5,
    question: "Can Dapp read our social ID info?",
    answer:
      "No, social IDs are hashed (SHA-256) i.e. encrypted and given to the Dapps.",
  },
];
